<template>
    <div>
        <PatientHeader :patient="patient"></PatientHeader>
        <br/>
        <ul class="nav nav-tabs">
            <li class="active"><a href="#home" data-toggle="tab">Orders</a></li>
            <li><a href="#profile" data-toggle="tab">Med Profile</a></li>
            <ul class="nav nav-pills pull-right">
                <li><a href="#">Print Reports</a></li>
                <li><a href="#">Edit Details</a></li>
            </ul>
        </ul>
        <div id="myTabContent" class="tab-content">
            <div class="tab-pane fade active in" id="home">
                <PatientOrderItems :patient="patient" start-date="2017-10-29" end-date="2017-11-25"></PatientOrderItems>

                <!--<MedProfileForm :patient="patient" start-date="2017-10-01" end-date="2017-10-28"></MedProfileForm>-->
            </div>
            <div class="tab-pane fade" id="profile">
                <MedProfileForm :patient="patient" start-date="2017-10-01" end-date="2017-10-28"></MedProfileForm>
            </div>
        </div>
        
    </div>
</template>


<script>
    import PatientHeader from "../appcontrols/patientHeader/patientHeader.scp.html"
    import PatientOrderItems from "../appcontrols/PatientOrderItems/PatientOrderItems.scp.html"
    import MedProfileForm from "../appcontrols/MedProfileForm/MedProfileForm.scp.html"

    //import ReorderForm from "../appcontrols/reorderForm/reorderform.scp.html"
    //import { ReorderItemDto } from "./../../dto/ReorderItemDto"
    //import { DrugDto } from "./../../dto/DrugDto"
    import { PatientDto } from "./../../dto/PatientDto"
    //import { WardCycleDto } from "./../../dto/Dtos"
    import Dal from "./../../scripts/dataaccess"
    //import { FormElementController, FormValidator, FormElementValidator, StringValidators } from './../../scripts/formcontrols'


    export default {
        data: function () {
            return {
                patient: new PatientDto(),
            }
        },
        mounted: function () {
            var dal = new Dal();
            dal.GetPatient("37071812-a0b2-e711-80c2-000d3a223751").then(d => {
                this.patient = d;
                console.log(d)
            });

        }
        , components : {
            PatientHeader
            ,PatientOrderItems
            , MedProfileForm
        }
    }
</script>


// WEBPACK FOOTER //
// selectizetest.scp.html?9d1ef71a